import { ChamberSelect, type UsFilters, UsStateSelect, UsTableFilters } from 'components'
import { Checkbox, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { CommitteeTypeSelect } from 'components'
import React from 'react'

interface CommitteeFilterProps {
  filters: UsFilters
  updateFilters: (filters: any) => void
  doFilter: () => Promise<void>
  cleanFilters: () => void
}

export const CommitteeFilters: React.FC<CommitteeFilterProps> = ({ filters, updateFilters, doFilter, cleanFilters }) => {
  return (
    <UsTableFilters doFilter={doFilter} filters={filters} updateFilters={updateFilters} cleanFilters={cleanFilters}>
      <Grid item xs={9}>
      <FormControl variant="outlined" fullWidth={true}>
        <TextField
          label="Committee Name"
          value={filters.name ?? ''}
          onChange={(event) => { updateFilters({ name: event.target.value }) }}
          variant="outlined"
          fullWidth
        />
      </FormControl>
      </Grid>
      <Grid item xs={1}>
            <FormControl variant="outlined" fullWidth>
                <InputLabel>Status</InputLabel>
                <Select
                    value={filters.active === null ? 'all' : filters.active === true ? 'active' : 'inactive'}
                    onChange={(event) => {
                      const value = event.target.value
                      updateFilters({
                        active: value === 'all' ? null : value === 'active'
                      })
                    }}
                    label="Status"
                >
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="active">Active</MenuItem>
                    <MenuItem value="inactive">Inactive</MenuItem>
                </Select>
            </FormControl>
      </Grid>
      <Grid item xs={2}>
      <FormControlLabel
        control={
          <Checkbox
            checked={filters.subs}
            onChange={(event) => { updateFilters({ subs: event.target.checked }) }}
            name="subs"
          />
        }
        label="Include Subcommittees"
      />
      </Grid>
      <FormControl variant="outlined" fullWidth={true}>
        <CommitteeTypeSelect updateCommitteeType={(type) => { updateFilters({ type }) }} value={filters.type} disabled={false}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <ChamberSelect updateChamber={(chamber) => { updateFilters({ chamber }) }} value={filters.chamber} disabled={false}/>
      </FormControl>
      <FormControl variant="outlined" fullWidth={true}>
        <UsStateSelect value={filters.state} updateState={(state) => { updateFilters({ state }) }} disabled={false}/>
      </FormControl>
    </UsTableFilters>
  )
}
